import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { ChallengeSentimentEntity } from '../../entities/challenge-insights/challenge-sentiment.entity';

export interface ChallengeSentimentAggregateRootProps {
  before: ChallengeSentimentEntity;
  after: ChallengeSentimentEntity;
}

export class ChallengeSentimentAggregateRoot extends Entity<ChallengeSentimentAggregateRootProps> {
  protected _id: string;

  static create(
    props: ChallengeSentimentAggregateRootProps,
    entityId?: string
  ): ChallengeSentimentAggregateRoot {
    const id = entityId || v4();
    const entity = new ChallengeSentimentAggregateRoot({
      id,
      props,
    });
    return entity;
  }

  public validate(): void {}
  get metricType() {
    return this.props.after.metricType;
  }
  get beforeAverage() {
    return this.props.before.avg;
  }
  get average() {
    return this.props.after.avg;
  }
  get averageDeviation() {
    return this.average - this.beforeAverage;
  }
  get averageDeviationPercentage() {
    return this.averageDeviation !== 0 && this.beforeAverage !== 0
      ? 100 * (this.averageDeviation / this.beforeAverage)
      : 0;
  }

  get beforeValue() {
    return this.props.before.value;
  }
  get value() {
    return this.props.after.value;
  }
  get deviation() {
    return this.value - this.beforeValue;
  }
  get deviationPercentage() {
    return this.deviation !== 0 && this.beforeValue !== 0
      ? 100 * (this.deviation / this.beforeValue)
      : 0;
  }

  get afterUniqueUsersCount(): number {
    return this.props.after.uniqueUsers;
  }

  get beforeUniqueUsersCount(): number {
    return this.props.before.uniqueUsers;
  }
}
